/**
 * PDP-only: hide sticky header after check-delivery reaches the header line
 * while scrolling down; show again on scroll up.
 * Reuses theme class `.header.is-hidden`.
 */
(function () {
  function init() {
    var header = document.querySelector('.header');
    var gate = document.querySelector('.product-info [data-block-type="check-delivery"]');
    if (!header || !gate) return;

    var pastGate = false;
    var lastScrollY = window.scrollY || window.pageYOffset || 0;
    var ticking = false;
    var observer = null;

    function getHeaderOffset() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
      var parsed = parseFloat(raw);
      if (!isNaN(parsed) && parsed > 0) return parsed;
      return header.getBoundingClientRect().height || 0;
    }

    function syncPastGateFromRect() {
      pastGate = gate.getBoundingClientRect().top <= getHeaderOffset();
      if (!pastGate) {
        header.classList.remove('is-hidden');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var currentY = window.scrollY || window.pageYOffset || 0;
        var scrollingDown = currentY > lastScrollY;
        var scrollingUp = currentY < lastScrollY;

        // Keep gate state in sync (covers resize / IO edge cases)
        syncPastGateFromRect();

        if (!pastGate || currentY <= 0) {
          header.classList.remove('is-hidden');
        } else if (scrollingUp) {
          header.classList.remove('is-hidden');
        } else if (scrollingDown) {
          header.classList.add('is-hidden');
        }

        lastScrollY = currentY;
        ticking = false;
      });
    }

    function setupObserver() {
      if (!('IntersectionObserver' in window)) {
        syncPastGateFromRect();
        return;
      }

      if (observer) observer.disconnect();

      var headerOffset = Math.max(0, Math.round(getHeaderOffset()));
      // 1px detection band at the sticky header bottom
      var bottomInset = Math.max(0, window.innerHeight - headerOffset - 1);

      observer = new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          if (!entry) return;
          // Intersecting the band, or already scrolled above it
          pastGate = entry.isIntersecting || entry.boundingClientRect.top < headerOffset;
          if (!pastGate) {
            header.classList.remove('is-hidden');
          }
        },
        {
          root: null,
          rootMargin: '-' + headerOffset + 'px 0px -' + bottomInset + 'px 0px',
          threshold: 0
        }
      );
      observer.observe(gate);
      syncPastGateFromRect();
    }

    setupObserver();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', setupObserver, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
